/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import {
  useBulkDeleteWarmupAccounts,
  useDeleteWarmupAccount,
  useWarmupAccounts,
  useWarmupStats,
} from "@/hooks/use-mailbox";
import { useServices } from "@/services/hooks/useServices";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AgGridReact } from "ag-grid-react";
import { useRef, useState } from "react";
import { toast } from "sonner";
import Trash from "@/components/icons/trash";

// export const Route = createFileRoute('/_private/mailboxes/warmup-account-tab')({
//   component: RouteComponent,
// })

// function RouteComponent() {
//     const [selectedRows, setSelectedRows] = useState<any[]>([]);
//     const [showDeleteDialog, setShowDeleteDialog] = useState(false);
//     const { data: warmupAccounts, isLoading } = useWarmupAccounts();
//     const { mutate: deleteWarmup } = useDeleteWarmupAccount();
//     const { mutate: bulkDelete } = useBulkDeleteWarmupAccounts();
//     const { data: warmupStats } = useWarmupStats();

//      const headerCardStats = [
//     {
//       title: "Total Warmup Accounts",
//       value: warmupAccounts?.length || 0,
//       icon: PlugsConnected,
//     },
//     {
//       title: "Total Warmup reviced",
//       value: warmupAccounts?.length || 0,
//       icon: Plugs,
//     },

//   ];

//     const handleDelete = async (id: string) => {
//       try {
//         await deleteWarmup(id);
//         toast.success("Warmup account deleted successfully");
//       } catch (error) {
//         toast.error("Failed to delete warmup account");
//       }
//     };

//     const handleBulkDelete = async () => {
//       try {
//         await bulkDelete(selectedRows.map((row) => row._id));
//         setShowDeleteDialog(false);
//         toast.success("Selected warmup accounts deleted successfully");
//       } catch (error) {
//         toast.error("Failed to delete warmup accounts");
//       }
//     };

//     const colDefs = [
//       {
//         field: "email",
//         headerName: "Email",
//         flex: 1,
//       },
//       {
//         field: "createdAt",
//         headerName: "Created At",
//         flex: 1,
//         valueFormatter: (params: any) => {
//           return new Date(params.value).toLocaleDateString();
//         },
//       },
//       {
//         field: "todayEmails",
//         headerName: "Today's Emails",
//         flex: 1,
//         valueGetter: (params: any) => {
//           const stats = warmupStats?.find(s => s.email === params.data.email);
//           return stats?.todayStats.total || 0;
//         },
//       },
//       {
//         field: "totalEmails",
//         headerName: "Total Emails",
//         flex: 1,
//         valueGetter: (params: any) => {
//           const stats = warmupStats?.find(s => s.email === params.data.email);
//           return stats?.overallStats.total || 0;
//         },
//       },
//       {
//         field: "actions",
//         headerName: "Actions",
//         width: 100,
//         cellRenderer: (params: any) => (
//           <Button
//             variant="ghost"
//             size="icon"
//             onClick={() => handleDelete(params.data._id)}
//           >
//             <Trash2 className="h-4 w-4" />
//           </Button>
//         ),
//       },
//     ];

//     const totalTodayEmails = warmupStats?.reduce((acc, stat) => acc + stat.todayStats.total, 0) || 0;
//     const totalOverallEmails = warmupStats?.reduce((acc, stat) => acc + stat.overallStats.total, 0) || 0;

//     return (
//       <div className="space-y-4">
//         <div className="grid grid-cols-2 gap-4 mb-4">
//           <Card>
//             <CardHeader className="pb-2">
//               <CardTitle className="text-sm font-medium">Today's Emails</CardTitle>
//             </CardHeader>
//             <CardContent>
//               <div className="text-2xl font-bold">{totalTodayEmails}</div>
//             </CardContent>
//           </Card>
//           <Card>
//             <CardHeader className="pb-2">
//               <CardTitle className="text-sm font-medium">Total Emails</CardTitle>
//             </CardHeader>
//             <CardContent>
//               <div className="text-2xl font-bold">{totalOverallEmails}</div>
//             </CardContent>
//           </Card>
//         </div>

//         <div className="flex justify-end">
//           {selectedRows.length > 0 && (
//             <Button
//               variant="destructive"
//               onClick={() => setShowDeleteDialog(true)}
//             >
//               Delete Selected ({selectedRows.length})
//             </Button>
//           )}
//         </div>

//         <DataTable
//           rowData={warmupAccounts ?? []}
//           columnDefs={colDefs}
//           height={500}
//           // onSelectionChanged={(rows) => setSelectedRows(rows)}
//           loading={isLoading}
//         />

//         <AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
//           <AlertDialogContent>
//             <AlertDialogHeader>
//               <AlertDialogTitle>Are you sure?</AlertDialogTitle>
//               <AlertDialogDescription>
//                 This will permanently delete {selectedRows.length} selected warmup accounts.
//                 This action cannot be undone.
//               </AlertDialogDescription>
//             </AlertDialogHeader>
//             <AlertDialogFooter>
//               <AlertDialogCancel>Cancel</AlertDialogCancel>
//               <AlertDialogAction onClick={handleBulkDelete}>
//                 Delete
//               </AlertDialogAction>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialog>
//       </div>
//     );
// }

interface WarmupTabProps {
  setshowWarmupTab: (show: boolean) => void;
}

export function WarmupTab() {
  const gridRef = useRef<AgGridReact>(null);
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [showBulkDeleteDialog, setShowBulkDeleteDialog] = useState(false);
  const [showSingleDeleteDialog, setShowSingleDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const { data: warmupAccounts, isLoading } = useWarmupAccounts();
  const { mutate: deleteWarmup } = useDeleteWarmupAccount();
  const { mutate: bulkDelete } = useBulkDeleteWarmupAccounts();
  const { data: warmupStats } = useWarmupStats();
  const { warmupService } = useServices();

  const handleDelete = async (id: string) => {
    setDeleteId(id);
    setShowSingleDeleteDialog(true);
  };

  const handleExportCsv = async () => {
    try {
      const response = await warmupService.exportWarmupsAsCsv();
      const blob = new Blob([response as unknown as BlobPart], {
        type: "text/csv",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "warmups.csv";
      a.click();
    } catch (error) {
      console.error("Failed to export CSV:", error);
    }
  };

  const confirmSingleDelete = async () => {
    if (!deleteId) return;

    try {
      await deleteWarmup(deleteId);
      setShowSingleDeleteDialog(false);
      setDeleteId(null);
      toast.success("Warmup account deleted successfully");
    } catch (error) {
      toast.error("Failed to delete warmup account");
    }
  };

  const handleBulkDelete = async () => {
    try {
      await bulkDelete(selectedRows.map((row) => row._id));
      setShowBulkDeleteDialog(false);
      setSelectedRows([]);
      toast.success("Selected warmup accounts deleted successfully");
    } catch (error) {
      toast.error("Failed to delete warmup accounts");
    }
  };

  const colDefs = [
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      valueFormatter: (params: any) => {
        return new Date(params.value).toLocaleDateString();
      },
    },
    {
      field: "todayEmails",
      headerName: "Today's Emails",
      flex: 1,
      valueGetter: (params: any) => {
        const stats = warmupStats?.find((s) => s.email === params.data.email);
        return stats?.todayStats.total || 0;
      },
    },
    {
      field: "totalEmails",
      headerName: "Total Emails",
      flex: 1,
      valueGetter: (params: any) => {
        const stats = warmupStats?.find((s) => s.email === params.data.email);
        return stats?.overallStats.total || 0;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      cellRenderer: (params: any) => (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => handleDelete(params.data._id)}
          className="delete-button group"
        >
          <Trash className="h-4 w-4" />
        </Button>
      ),
    },
  ];

  const onSelectionChanged = () => {
    const selectedNodes = gridRef?.current?.api.getSelectedNodes();
    const selectedData = selectedNodes?.map((node) => node.data) || [];
    setSelectedRows(selectedData);
  };

  const totalTodayEmails =
    warmupStats?.reduce((acc, stat) => acc + stat.todayStats.total, 0) || 0;
  const totalOverallEmails =
    warmupStats?.reduce((acc, stat) => acc + stat.overallStats.total, 0) || 0;

  return (
    <div className="space-y-4">
      <Button onClick={handleExportCsv}>Export CSV</Button>
      {/* <div className="grid grid-cols-2 gap-4 mb-4">
      <Card className="relative overflow-hidden border-none bg-gradient-to-br from-blue-50 to-white dark:from-blue-950 dark:to-slate-900 group">
        
        <CardHeader className="relative flex flex-row items-center gap-4">
          <div className="rounded-full bg-blue-100 dark:bg-blue-900/50 p-2.5 group-hover:scale-110 transition-transform">
            <Flame className="size-5 text-blue-600 dark:text-blue-400" />
          </div>
          <CardTitle className="text-lg font-medium text-blue-900 dark:text-blue-100">
            Today&apos;s warmup received
          </CardTitle>
        </CardHeader>
        <CardContent className="relative">
          <p className="text-4xl font-bold text-blue-600 dark:text-blue-400">{totalTodayEmails}</p>
        </CardContent>
      
      </Card>

      <Card className="relative overflow-hidden border-none bg-gradient-to-br from-blue-50 to-white dark:from-blue-950 dark:to-slate-900 group">
        
        <CardHeader className="relative flex flex-row items-center gap-4">
          <div className="rounded-full bg-blue-100 dark:bg-blue-900/50 p-2.5 group-hover:scale-110 transition-transform">
            <Activity className="size-5 text-blue-600 dark:text-blue-400" />
          </div>
          <CardTitle className="text-lg font-medium text-blue-900 dark:text-blue-100">Total warmup received</CardTitle>
        </CardHeader>
        <CardContent className="relative">
          <p className="text-4xl font-bold text-blue-600 dark:text-blue-400">{totalOverallEmails}</p>
        </CardContent>
        
      </Card>
      </div> */}

      {/* <div className="flex justify-end">
        {selectedRows.length > 0 && (
          <Button
            variant="destructive"
            onClick={() => setShowBulkDeleteDialog(true)}
          >
            Delete Selected ({selectedRows.length})
          </Button>
        )}
      </div>

      <DataTable
        rowData={warmupAccounts ?? []}
        columnDefs={colDefs}
        height={500}
        onSelectionChanged={onSelectionChanged}
        ref={gridRef}
        loading={isLoading}
      />

      <AlertDialog open={showBulkDeleteDialog} onOpenChange={setShowBulkDeleteDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Are you sure?</AlertDialogTitle>
            <AlertDialogDescription>
              This will permanently delete {selectedRows.length} selected warmup accounts.
              This action cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={handleBulkDelete}>
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={showSingleDeleteDialog} onOpenChange={setShowSingleDeleteDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete Warmup Account</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to delete this warmup account? This action cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => setDeleteId(null)}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={confirmSingleDelete}>
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog> */}
    </div>
  );
}

// Export the route configuration
export const Route = createFileRoute("/_private/mailboxes/warmup-account-tab")({
  component: WarmupTab,
});
